<template>
  <modal
    v-if="visible"
    :visible="visible"
    @click-outside-modal="$emit('close')"
  >
    <div
      class="flex w-[500px] flex-col justify-center rounded bg-white p-8 px-4"
    >
      <h3 class="text-left text-3xl text-dark-gray">Add Email Address</h3>
      <p class="my-4 text-left text-body-color">
        Enter an email address to be notified of new rate confirmations sent to
        your company.
      </p>

      <form-field
        label="Email"
        :value="email"
        placeholder="Enter email address"
        name="email"
        :on-input="onInput"
        :on-blur="handleEmailBlur"
        :error="emailError"
      />
      <form-field
        label="Confirm Email"
        :value="confirmEmail"
        placeholder="Confirm email address"
        name="confirmEmail"
        :on-input="onInput"
        :on-blur="handleConfirmEmailBlur"
        :error="confirmEmailError"
      />
      <p class="text-xs text-body-color">
        Note: All registered users on this carrier will be notified of this
        change.
      </p>

      <div class="mt-8 flex w-full flex-col md:flex-row-reverse md:gap-x-2">
        <button-main
          :disabled="isEmailDisabled"
          @click="$emit('add', email)"
        >
          Add Email
        </button-main>
        <button-main
          variant="secondary"
          class="mt-3 md:mt-0"
          @click="$emit('close')"
        >
          Cancel
        </button-main>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/modals/Modal.vue';
import ButtonMain from '@/components/Button.vue';
import FormField from '@/components/FormField.vue';
import { isEmail } from '@/common/validators';

export default {
  name: 'AddRateConfirmationEmailModal',
  components: {
    Modal,
    ButtonMain,
    FormField,
  },
  props: {
    visible: Boolean,
  },
  data() {
    return {
      email: '',
      confirmEmail: '',
      emailError: '',
      confirmEmailError: '',
    };
  },
  computed: {
    isEmailDisabled() {
      if (this.email.length === 0 || this.email !== this.confirmEmail) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    onInput(e) {
      const isValidEmail = isEmail(e.target.value);
      if (isValidEmail) {
        if (e.target.name === 'confirmEmail') {
          this.confirmEmailError = '';
        } else {
          this.emailError = '';
        }
      } else {
        this.emailError = '';
        this.confirmEmailError = '';
      }

      this[e.target.name] = e.target.value;
    },
    handleEmailBlur() {
      if (!isEmail(this.email)) {
        this.emailError = 'Must be a valid email.';
      }
    },
    handleConfirmEmailBlur() {
      const validEmail = isEmail(this.email);
      const validConfirmEmail = isEmail(this.confirmEmail);

      if (!validConfirmEmail) {
        this.confirmEmailError = 'Must be a valid email.';
      } else if (
        validEmail &&
        validConfirmEmail &&
        this.email !== this.confirmEmail
      ) {
        this.confirmEmailError = 'Email addresses must match';
      } else {
        this.confirmEmailError = '';
      }
    },
  },
  emits: ['close', 'add'],
  setup(_, { emit }) {
    const onCancel = () => {
      emit('close');
    };

    return {
      onCancel,
    };
  },
};
</script>
